var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":"buscaCid"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('autosuggest',{ref:"autoBuscaCid",attrs:{"id":"buscaCid","url":_vm.$urlBase + '/cidades/buscaCidades',"default":_vm.carregaCidade()},on:{"result":_vm.selecionaCidade}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }